import { render } from "./wokerDetail1.vue?vue&type=template&id=a06d0024&scoped=true"
import script from "./wokerDetail1.vue?vue&type=script&lang=js"
export * from "./wokerDetail1.vue?vue&type=script&lang=js"

import "./wokerDetail1.vue?vue&type=style&index=0&id=a06d0024&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a06d0024"]])

export default __exports__